import React from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import Home from './pages/Home';
import './App.css';
const App = () => {
  return (
    <>
      <Router>
        <Home />
        <Switch>
          <Route path='/' exact />
        </Switch>
      </Router>


    </>
  );
}

export default App;
